/**
 * Normative constants from docs/PROTOCOL.md §10.
 *
 * The C++ plugin mirrors these in apps/plugin/source/protocol/Wire.h. If you change
 * a value here, change it there too — `pnpm --filter @auxcast/protocol test` has a
 * check that the two files agree.
 */
export const PROTOCOL_VERSION = 1;
/** First byte of every binary frame. "AC" for AuxCast. */
export const MAGIC = 0xac;
/** Fixed binary frame header size, in bytes. */
export const FRAME_HEADER_BYTES = 16;
export const LIMITS = {
    PROTOCOL_VERSION,
    MAGIC,
    FRAME_HEADER_BYTES,
    /** Largest accepted binary frame (header + payload). */
    MAX_FRAME_BYTES: 8192,
    /** Largest accepted JSON control message. */
    MAX_CONTROL_BYTES: 16384,
    /** A peer that has not sent `hello` within this window is closed. */
    HELLO_TIMEOUT_MS: 10_000,
    HEARTBEAT_INTERVAL_MS: 10_000,
    HEARTBEAT_TIMEOUT_MS: 30_000,
    /** How long a session survives its sender disconnecting, so links stay valid. */
    SESSION_GRACE_MS: 120_000,
    /** Drop frames for a listener whose socket buffer is above this. */
    LISTENER_HIGH_WATER_BYTES: 262_144,
    /** Disconnect a listener that stays above the high-water mark this long. */
    LISTENER_STALL_MS: 15_000,
    MAX_INGEST_BYTES_PER_SEC: 262_144,
    MAX_LISTENERS_PER_SESSION: 100,
    /** Consecutive lost frames the decoder will conceal before resetting. */
    MAX_PLC_FRAMES: 5,
    SUPPORTED_SAMPLE_RATES: [48_000],
    SUPPORTED_FRAME_MS: [10, 20, 40, 60],
    SUPPORTED_CHANNELS: [1, 2],
    BITRATE_RANGE: [16_000, 512_000],
    /** Session id length, base58. ~64 bits of entropy. */
    SESSION_ID_LENGTH: 11,
    /** Random part of an API key, base62. ~256 bits. */
    API_KEY_RANDOM_LENGTH: 43,
    API_KEY_PREFIX: 'ak_',
};
/** Defaults the plugin ships with; also what the web player assumes pre-`ready`. */
export const DEFAULTS = {
    sampleRate: 48_000,
    channels: 2,
    frameMs: 20,
    bitrate: 128_000,
    /** Listener jitter buffer target, in milliseconds. */
    jitterBufferMs: 120,
    /** Hard ceiling on the jitter buffer before the oldest audio is discarded. */
    maxJitterBufferMs: 600,
};
/** Samples per channel in one frame at a given sample rate and frame duration. */
export function samplesPerFrame(sampleRate, frameMs) {
    return Math.round((sampleRate * frameMs) / 1000);
}
//# sourceMappingURL=limits.js.map